module.exports = __webpack_public_path__ + "spine/Farm_Lady.json?217db31a00b55bb531a47c8bc0e2ddfa";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spine/citizens/woman/Farm_Lady.json
// module id = 1747
// module chunks = 3